import { useFeatureValue } from '@monofront/business/contexts';
import {
  MONTHLY_SUBSCRIPTION_PRICE,
  ANNUAL_SUBSCRIPTION_PRICE,
} from '@monofront/business/constants/remoteConfigs';

interface ISubscriptionPrice {
  annualSubscriptionPrice: number;
  monthlySubscriptionPrice: number;
}

const useSubscriptionPrice = (): ISubscriptionPrice => {
  const annualSubscriptionPrice = useFeatureValue(...ANNUAL_SUBSCRIPTION_PRICE);
  const monthlySubscriptionPrice = useFeatureValue(
    ...MONTHLY_SUBSCRIPTION_PRICE,
  );

  return { annualSubscriptionPrice, monthlySubscriptionPrice };
};

export default useSubscriptionPrice;
